import * as React from 'react';
import styles from './tiles-index.scss';

export interface TileProps {
  name: string;
  isSelected: boolean;
  onClick?: (name: string) => void;
}

export const Tile = ({ name, isSelected, onClick }: TileProps) => {
  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick(name);
  };

  return (
      <button 
        disabled={isSelected} 
        className={`btn ${styles.alphabetControlBtn}`} 
        onClick={clickHandler}>
        {name}
      </button>
  );
};
